import { ContactHelp } from "Components/CommonService";
import React from "react";
import { Col, Container, Row, Button, Breadcrumb, Accordion, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useListStoreFaqsQuery } from "../../redux/services/store/storeFaqApi";

const FAQ = () => {
    const { i18n } = useTranslation();
    const langCode = (i18n.resolvedLanguage || i18n.language || "en").toString().trim() || "en";
    const { data, isLoading, isFetching } = useListStoreFaqsQuery({
        lang_code: langCode,
        fallback_lang_code: "en",
        active_only: true,
    });
    const faqItems = data?.items ?? [];

    return (
        <React.Fragment>
            <section className="ecommerce-about bg-primary">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6} >
                            <div className="text-center">
                                <h1 className="text-white mb-0">Frequently Asked Questions</h1>
                                <Breadcrumb bsPrefix="breadcrumb breadcrumb-light justify-content-center mt-4 fs-15">
                                    <Breadcrumb.Item href="#">Shop</Breadcrumb.Item>
                                    <Breadcrumb.Item active aria-current="page">Faq's</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={12}>
                            <div className="text-center">
                                <h3>Have any Questions ?</h3>
                                <p className="text-muted mb-4">Find quick answers about orders, payments, delivery, customization, and more.</p>
                                <div className="hstack flex-wrap gap-2 justify-content-center">
                                    <Button
                                        as="a"
                                        href="mailto:support@fionaziya.in"
                                        variant="primary"
                                        className="btn-label rounded-pill"
                                    >
                                        <i className="ri-mail-line label-icon align-middle rounded-pill fs-16"></i> Email Us
                                    </Button>
                                    <Button
                                        as="a"
                                        href="tel:+919207448595"
                                        variant="info"
                                        className="btn-label rounded-pill"
                                    >
                                        <i className="ri-phone-line label-icon align-middle rounded-pill fs-16"></i> Call Us
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className="gy-4 justify-content-center mt-2">
                        <Col xxl={8} lg={8}>
                            <div>
                                <div className="mb-4">
                                    <h5 className="fs-16 mb-0 fw-semibold">General Questions</h5>
                                </div>
                                {isLoading || isFetching ? (
                                    <div className="py-4 text-muted d-flex align-items-center gap-2">
                                        <Spinner size="sm" animation="border" />
                                        Loading FAQs...
                                    </div>
                                ) : faqItems.length > 0 ? (
                                    <Accordion defaultActiveKey='0' className="accordion-border-box">
                                        {faqItems.map((item, idx) => (
                                            <Accordion.Item eventKey={String(idx)} key={`faq-page-${item.id}`}>
                                                <Accordion.Header className="h2">
                                                    {item.question}
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div
                                                        className="text-muted"
                                                        dangerouslySetInnerHTML={{ __html: item.answer || "" }}
                                                    />
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ))}
                                    </Accordion>
                                ) : (
                                    <div className="text-muted py-4">No FAQs available right now.</div>
                                )}

                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <ContactHelp cname="section" />
        </React.Fragment>
    )
}
export default FAQ;
